import dayjs from "dayjs";

export type ModeInfo = {
  createdWhen: string | null;
  mode: "new" | "existing" | "review" | "edit";
  monthsSinceReview: number;
};

export const deriveFinancialStatementMode = (
  createdWhen: string | null,
): ModeInfo => {
  if (!createdWhen) {
    return { createdWhen: null, mode: "new", monthsSinceReview: 0 };
  }

  const created = dayjs(createdWhen);
  const months = dayjs().diff(created, "month");

  return {
    createdWhen: created.format("YYYY-MM-DD"),
    mode: months !== null && months < 12 ? "review" : "edit",
    monthsSinceReview: months,
  };
};
